import * as yup from "yup";
import { validateBandwidthAreaCode } from "./mmsApiErrorMessage";

export const bandwidthAreaCodeField = yup
  .string()
  .required("Area code is required")
  .matches(/^[0-9]{3}$/, "Area code must be exactly 3 digits")
  .test("not-starting-with-0-or-1", "Area code cannot start with 0 or 1", (value) => {
    if (!value) return true;
    return !value.startsWith("0") && !value.startsWith("1");
  })
  .test("bandwidth-area-code", function (value) {
    if (!value) return true;
    const message = validateBandwidthAreaCode(value);
    if (message) {
      return this.createError({ message });
    }
    return true;
  });
